import React from "react";
import { motion } from "framer-motion";
import { ChevronsRight } from "lucide-react";

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.18, delayChildren: 0.15 },
  },
};

const lineUp = {
  hidden: { y: 40, opacity: 0 },
  show: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  },
};

export default function CoverPage({ studio, onOpen }) {
  const s = studio || {};
  return (
    <div
      className="relative w-full h-full paper-bg flex flex-col items-center justify-center text-center overflow-hidden"
      data-testid="cover-page"
    >
      {/* Background image with parallax feel */}
      {s.coverImage && (
        <motion.div
          className="absolute inset-0"
          initial={{ scale: 1.15, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <img
            src={s.coverImage}
            alt="Studio da Beleza Bruna Reis"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 page-overlay" />
        </motion.div>
      )}

      {/* Thin gold frame */}
      <div className="absolute inset-3 sm:inset-5 border border-[rgba(212,175,55,0.28)] pointer-events-none" />

      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="relative z-10 px-6 flex flex-col items-center"
      >
        <div className="overflow-hidden">
          <motion.div variants={lineUp}>
            {s.logoImage ? (
              <img
                src={s.logoImage}
                alt={`${s.brandName || "Bruna Reis"} logo`}
                data-testid="cover-logo-image"
                className="h-52 w-52 sm:h-64 sm:w-64 object-contain mx-auto drop-shadow-[0_6px_30px_rgba(0,0,0,0.7)]"
              />
            ) : (
              <span className="font-heading text-gold-metallic shimmer text-7xl sm:text-8xl font-semibold tracking-tight leading-none">
                BR
              </span>
            )}
          </motion.div>
        </div>

        {!s.logoImage && (
          <div className="overflow-hidden mt-1">
            <motion.p
              variants={lineUp}
              className="font-script text-3xl sm:text-4xl text-[var(--champagne)]"
            >
              {s.brandName || "Bruna Reis"}
            </motion.p>
          </div>
        )}

        {!s.logoImage && (
          <div className="overflow-hidden mt-3">
            <motion.p
              variants={lineUp}
              className="font-body text-[0.62rem] sm:text-xs uppercase tracking-[0.42em] text-[var(--nude)]"
            >
              {s.studioName || "Studio da Beleza"}
            </motion.p>
          </div>
        )}

        <motion.div variants={lineUp} className="gold-hairline w-28 my-6" />

        <div className="overflow-hidden max-w-xs">
          <motion.p
            variants={lineUp}
            className="font-script text-2xl sm:text-3xl text-[var(--offwhite)] leading-snug"
          >
            {s.sloganMain || "Realçando sua beleza com cuidado, carinho e excelência!"}
          </motion.p>
        </div>

        <motion.button
          variants={lineUp}
          data-testid="cover-open-button"
          onClick={onOpen}
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.97 }}
          className="mt-9 px-9 py-3 bg-[var(--gold)] text-[var(--deep-black)] font-body uppercase tracking-[0.22em] text-[0.7rem] font-semibold hover:bg-[var(--champagne)] transition-colors duration-300"
        >
          Abrir catálogo
        </motion.button>

        <motion.div
          variants={lineUp}
          className="mt-6 flex items-center gap-2 text-[var(--muted)] font-body text-[0.62rem] uppercase tracking-[0.28em]"
        >
          Arraste para o lado
          <ChevronsRight size={15} className="text-[var(--gold)]" strokeWidth={1.5} />
        </motion.div>
      </motion.div>
    </div>
  );
}
